import style from "./style.module.scss";
import IcArrow from "../Svg/IcArrow";

export default function SpoilerLink(props) {

  const { text, bold } = props;
  return (
    <span className={`${style.spoiler_link} ${bold ? "fw-bold" : ""}`}>
      <span {...props}>{text}</span>
      <IcArrow direction="bottom" />
    </span>
  );
}